<template>
    <div class="bg-gray-800 py-6">
        <div class="max-w-7xl mx-auto px-4 sm:px-6">
            <slot name="nav"></slot>
            <div class="mt-2 md:flex md:items-center md:justify-between">
                <div class="flex-1 min-w-0">
                    <slot name="content"></slot>
                </div>
                <div class="mt-4 flex-shrink-0 flex md:mt-0 md:ml-4">
                    <slot name="buttons"></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "PageHeader"
}
</script>